export default "__VITE_ASSET__ChYSSKQy__"